/// <amd-module name="VSSUI/Components/ContextualMenuButton/DropdownButton" />

import * as React from "react";
import { IContextualMenuButtonProps } from "../../Components/ContextualMenuButton/ContextualMenuButton.Props";
import { ContextualMenuButton } from "../../Components/ContextualMenuButton/ContextualMenuButton";

/**
 * Implementation of the ContextualMenuButton that uses the chevron icon
 */
/** @deprecated Please use import { Menu } from "VSSUI/Menu" */
export class DropdownButton extends React.Component<IContextualMenuButtonProps> {
    public render(): JSX.Element {
        return <ContextualMenuButton {...this.props} iconProps={{ iconName: "ChevronDown" }} />;
    }
}
